import React, { useEffect, useState } from "react";

const AboutBottomComponent = () => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1500);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1500);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="row g-sm-4 g-2 align-items-center">
      <div className="col-xl-6">
        <div className="d-flex flex-column h-100">
          {/* Top Image */}
          <div
            className={`fresh-image flex-fill mb-2 ${
              isWideScreen ? "heigth-section-home-half-fifteen" : "heigth-section-home-half"
            }`}
          >
            <div
              className="bg-size blur-up lazyloaded"
              style={{
                backgroundImage: "url(../assets/images/Platfroms/platform2.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                display: "block",
                height: "100%",
              }}
            ></div>
          </div>
          {/* Bottom Image */}
          <div
            className={`fresh-image flex-fill mb-2 ${
              isWideScreen ? "heigth-section-home-half-fifteen" : "heigth-section-home-half"
            }`}
          >
            <div
              className="bg-size blur-up lazyloaded"
              style={{
                backgroundImage: "url(../assets/images/Platfroms/platform3.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                display: "block",
                height: "100%",
              }}
            ></div>
          </div>
        </div>
      </div>
      {/* Left Image */}
      <div className="col-xl-6">
        <div
          className={`fresh-image-2 ${
            isWideScreen ? "heigth-section-home-full-fifteen" : "heigth-section-home-full"
          }`}
        >
          <div
            className="bg-size blur-up lazyloaded"
            style={{
              backgroundImage: "url(../assets/images/Platfroms/updatedhadshake.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              height: "100%",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default AboutBottomComponent;
